<template>
  <ion-page>
    <ion-header>
      <ion-toolbar>
        <ion-buttons slot="start">
          <ion-back-button default-href="/"></ion-back-button>
        </ion-buttons>
        <ion-title>Request Ambulance</ion-title>
      </ion-toolbar>
    </ion-header>
    <ion-content padding>
      <div style="height: 300px; width: 100%">
            <l-map ref="mymap" style="height: 300px;" :zoom="zoom" :center="center">
                <l-tile-layer :url="url" :attribution="attribution"></l-tile-layer>
                <l-marker v-if="marker.location" :lat-lng="marker.location">
                  <l-popup>
                    Your Location
                  </l-popup>
                </l-marker>
            </l-map>
        </div>
        <div id="form_card">
          <form autocomplete="off">
            <div id="mylist">
              <vue-google-autocomplete
                  ref="address"
                  id="map"
                  classname="form-control"
                  placeholder="Please type your location"
                  v-on:placechanged="getAddressData"
                  country="za"
              >
              </vue-google-autocomplete>
            </div>
            <ion-item id="rounded" lines="none">
                <ion-label position="floating">Phone number</ion-label>
                <ion-input :value="new_request.phone_number" @ionInput="new_request.phone_number=$event.target.value"></ion-input>
            </ion-item>
            <ion-item id="rounded" lines="none">
                <ion-label position="floating">Reason for request</ion-label>
                <ion-input :value="new_request.reason" @ionInput="new_request.reason=$event.target.value"></ion-input>
            </ion-item>
            <ion-button @click="saveRequest" expand="full">Request Ambulance</ion-button>
        </form>
       </div>
    </ion-content>
  </ion-page>
</template>

<script>
import VueGoogleAutocomplete from 'vue-google-autocomplete';
import 'bootstrap/dist/css/bootstrap.min.css';
import Modal from './ResultsModal';
import {LMap,LTileLayer,LMarker,LPopup} from 'vue2-leaflet';
import L from 'leaflet';
export default {
    name:'ambulance',
    components:{
        LMap,
        LTileLayer,
        LMarker,
        LPopup,
        VueGoogleAutocomplete
    },
    data(){
        return {
            selected_address:null,
            result_data:null,
            result_id:null,
            marker:{
              location:null,
            },
            new_request:{
              phone_number:'',
              status:'PROCESSING',
              details:'PROCESSING',
              reason:'',
              lat:'',
              long:'',
              address:''
            },
            zoom:6,
            center: L.latLng(-29.520628, 31.043783),
            url:'http://{s}.tile.osm.org/{z}/{x}/{y}.png',
            attribution:'&copy; <a href="http://osm.org/copyright">OpenStreetMap</a> contributors',
        }
    },
    methods:{
        loadMap(){
            setTimeout(() => {
                this.$refs.mymap.mapObject.invalidateSize(); 
            }, 100);
        },
        getAddressData: function (addressData, placeResultData, id) {
            this.selected_address = addressData;
            this.result_data=placeResultData;
            this.result_id=id;
            this.new_request.address=this.result_data.formatted_address;
            this.new_request.lat=""+this.selected_address.latitude;
            this.new_request.long=""+this.selected_address.longitude;
            //set marker data
            this.marker.location=L.latLng(addressData.latitude, addressData.longitude);
            this.center=L.latLng(addressData.latitude, addressData.longitude);
        },
        showModal(){
            return this.$ionic.modalController.create(
                {
                    component:Modal,
                    componentProps:{
                        propsData:{
                            title:'Request Ambulance',
                            message:'Your request has been submitted and is being processed. You will be contacted with further instructions',
                            closeMe: () => {
                                this.$ionic.modalController.dismiss()
                            },
                            result:'success'
                        }
                    }
                }
            ).then(m=>m.present());
        },
        saveRequest(){
          return this.$ionic.loadingController
            .create({
            message: 'Please wait...',
            })
            .then(loading => {
                loading.present();
                const base_url=this.$store.get('base_url');
                this.$http.post(base_url+'/api/ambulances/',this.new_request)
                .then((res)=>console.log(res))
                .then(()=>loading.dismiss())
                .then(()=>this.showModal())
                .catch((err)=>{loading.dismiss();this.showModal();console.log(err)});
            })
        }
    },
    mounted(){
        this.loadMap();
        this.$refs.address.focus();
    }
}
</script>

<style scoped>
ion-toolbar {
  --ion-toolbar-background:#fbc414;
  --ion-text-color:white;
}
ion-back-button{
    --color:white;
}
ion-button{
    --background:#1b9346;
}
#rounded{
    --border-color: #d2d2d2;
  --border-radius: 10px;
  --border-width: 1px;
  --box-shadow: 2px gray;
  --highlight-height: 0;
  --background: #f8f9fa;
  margin: 10px;
}
 #mylist{
  padding-top: 10px;
  padding-left: 10px;
  padding-right: 10px;
}

</style>